// extracted by mini-css-extract-plugin
var _1 = "PhoneSelectControlContent-modulePhoneSelectControlContent__Tk5vK";
var _2 = "PhoneSelectControlContent-moduleflag__K9W5s";
var _3 = "PhoneSelectControlContent-moduleflagContainer__uHMd2";
var _4 = "PhoneSelectControlContent-modulevalue__gCDta";
export { _1 as "PhoneSelectControlContent", _2 as "flag", _3 as "flagContainer", _4 as "value" }
